import {
  LogicalOperatorEnumerator,
  LogicalOperatorsOptions,
  SupportedTypes,
} from "../Elements/FilterSelect/LogicalOperatorsOptions";
import QueryFilterBooleans from "./QueryFilterBooleans";
import QueryFilterDates from "./QueryFilterDates";
import QueryFilterNumbers from "./QueryFilterNumbers";
import QueryFilterStrings from "./QueryFilterStrings";

// Map for supported types and method calculation
const filtersCreators = {
  [SupportedTypes.String]: QueryFilterStrings,
  [SupportedTypes.Boolean]: QueryFilterBooleans,
  [SupportedTypes.Date]: QueryFilterDates,
  [SupportedTypes.Numeral]: QueryFilterNumbers,
};

/**
 * IoC which get the right function to calculate, create and return the Druid Filter
 */
const QueryFilterCreator = (supportedType) => {
  // get the function that will be returned to be calculating and creating the filter
  // having details from LogicalOperator
  return filtersCreators[supportedType];
};

/**
 * Returns the formatted list of values
 * @param {*} logicalOperator
 */
const getContainsValues = (logicalOperator) => {
  const list = logicalOperator.value.list;
  return list.length > 1
    ? `"${list.slice(0, list.length - 1).join(", ")} and ${
        list[list.length - 1]
      }"`
    : `"${list.join("")}"`;
};

/**
 * Returns value from A and B input
 * @param {*} logicalOperator
 */
const getIsBetween = (logicalOperator) =>
  `${logicalOperator.value.valueA} and ${logicalOperator.value.valueB}`;

/**
 * Formats the value as period
 * @param {*} logicalOperator
 */
const getTheLast = (logicalOperator) =>
  `${logicalOperator.value.value} ${logicalOperator.value.period}`;

/**
 * Returns the formatted date
 * @param {*} logicalOperator
 */
const getInBetween = (logicalOperator) =>
  `${logicalOperator.value.startDate} and ${logicalOperator.value.endDate}`;

/**
 * Returns the date for On period
 * @param {*} logicalOperator
 */
const getOn = (logicalOperator) => logicalOperator.value.startDate;

const getBoolean = (logicalOperator) => {
  const values = [];
  if (logicalOperator.value.checkbox_true) values.push("True");
  if (logicalOperator.value.checkbox_false) values.push("False");

  return values.join(" and ");
};

// Object map that contains method which returns the calculated value
const valuesMap = {
  [LogicalOperatorEnumerator.Equals]: (logicalOperator) =>
    logicalOperator.value.value,
  [LogicalOperatorEnumerator.DoesNotEqual]: (logicalOperator) =>
    logicalOperator.value.value,

  // contains
  [LogicalOperatorEnumerator.Contains]: getContainsValues,
  [LogicalOperatorEnumerator.DoesNotContain]: getContainsValues,

  // Has value
  [LogicalOperatorEnumerator.HasValue]: () => "value",
  [LogicalOperatorEnumerator.DoesNotHaveValue]: () => "value",

  // Is Between
  [LogicalOperatorEnumerator.IsBetween]: getIsBetween,
  [LogicalOperatorEnumerator.IsNotBetween]: getIsBetween,

  // Returns the value from input
  [LogicalOperatorEnumerator.LessThan]: (logicalOperator) =>
    logicalOperator.value.value,
  [LogicalOperatorEnumerator.GreaterThan]: (logicalOperator) =>
    logicalOperator.value.value,

  // The Last
  [LogicalOperatorEnumerator.InTheLast]: getTheLast,
  [LogicalOperatorEnumerator.BeforeTheLast]: getTheLast,

  // Between dates
  [LogicalOperatorEnumerator.InBetween]: getInBetween,
  [LogicalOperatorEnumerator.NotInBetween]: getInBetween,

  // On
  [LogicalOperatorEnumerator.On]: getOn,
  [LogicalOperatorEnumerator.NotOn]: getOn,

  [LogicalOperatorEnumerator.TrueFalse]: getBoolean,
};

/**
 * Returns the values applied into the logical operator properly formatted
 * @param {*} logicalOperator
 */
const getFilterValuesDecription = (logicalOperator) =>
  valuesMap[logicalOperator.description](logicalOperator);

/**
 * Returns the description of the filter that was applied
 */
export const getFilterDescription = (logicalOperator) => {
  // if no logical operator was set or it doesn't contain value
  if (!logicalOperator || (logicalOperator && !logicalOperator.value))
    if (
      logicalOperator &&
      [
        LogicalOperatorEnumerator.HasValue,
        LogicalOperatorEnumerator.DoesNotHaveValue,
      ].includes(logicalOperator.description)
    )
      // logicalOperator is not null but has no value
      return (
        LogicalOperatorsOptions.find(
          (lo) => lo.description === logicalOperator.description
        ).displayedValue + getFilterValuesDecription(logicalOperator)
      );
    else return "";

  const loApplied = LogicalOperatorsOptions.find(
    (lo) => lo.description === logicalOperator.description
  );

  return loApplied.displayedValue + getFilterValuesDecription(logicalOperator);
};

export default QueryFilterCreator;
